<template>
  <div class="hp_index">
      <div class="hp_header">
          <div class="hp_rule">
              <van-image width="0.35rem" height="0.37rem" src="https://oss.mcloud.moveclub.cn/mpms/20210309/1615278644-604732349905a.png" />
              <span>详细活动规则请点击</span>
              <div class="mvbutton" @click="show=true">查看规则</div>
          </div>
          <div class="hp_date">活动时间：{{matchinfo.start_time|startstate}}-{{matchinfo.end_time|state}}</div>
      </div>
      <div class="hp_body">
          <div class="hp_body_tit">百年之光</div>
          <div class="hp_body_notice">“百年之光”路线成次数</div>
          <div class="hp_medal">
              <div :class="[type>=1?'active':'']">
                  <van-image v-if="type>=1" width="0.94rem" height="0.94rem" src="https://oss.mcloud.moveclub.cn/mpms/20210309/1615278740-60473294d249f.png" />
                  <van-image v-else width="0.94rem" height="0.94rem" src="https://oss.mcloud.moveclub.cn/mpms/20210309/1615278732-6047328cb9c47.png" />
                  <span>初级勋章({{first}}次)</span>
              </div>
              <div class="hp_medal_1">
                  <van-image v-if="type>1" width="0.65rem" height="0.11rem" src="https://oss.mcloud.moveclub.cn/mpms/20210310/1615343133-60482e1d8506b.png" />
                  <van-image v-else width="0.65rem" height="0.11rem" src="https://oss.mcloud.moveclub.cn/mpms/20210310/1615343150-60482e2ef3bdd.png" />
              </div>
              <div :class="[type>=2?'active':'']">
                  <van-image v-if="type>=2" width="0.94rem" height="0.94rem" src="https://oss.mcloud.moveclub.cn/mpms/20210309/1615278755-604732a39473a.png" />
                  <van-image v-else width="0.94rem" height="0.94rem" src="https://oss.mcloud.moveclub.cn/mpms/20210309/1615278750-6047329e5b2a8.png" />
                  <span>中级勋章({{two}}次)</span>
              </div>
              <div class="hp_medal_2">
                  <van-image v-if="type>2" width="0.65rem" height="0.11rem" src="https://oss.mcloud.moveclub.cn/mpms/20210310/1615343133-60482e1d8506b.png" />
                  <van-image v-else width="0.65rem" height="0.11rem" src="https://oss.mcloud.moveclub.cn/mpms/20210310/1615343150-60482e2ef3bdd.png" />
              </div>
              <div :class="[type===3?'active':'']">
                  <van-image v-if="type===3" width="0.94rem" height="0.94rem" src="https://oss.mcloud.moveclub.cn/mpms/20210309/1615278768-604732b08d012.png" />
                  <van-image v-else width="0.94rem" height="0.94rem" src="https://oss.mcloud.moveclub.cn/mpms/20210309/1615278762-604732aa0cddb.png" />
                  <span>高级勋章({{three}}次)</span>
              </div>
          </div>
          <div class="hp_body_btn">
              <div class="chou" @click="goluck">好礼赢取</div>
              <div class="upload" @click="goto">去上传照片</div>
          </div>
      </div>
      <List v-model="loading" :finished="finished" finished-text="没有更多了" @load="getRankList">
        <div class="hp_rank">
            <div class="hp_rank_header"><div>排行榜</div></div>
            <div class="hp_rank_list">
                <div class="hp_rank_item" v-for="item in rankList" :key="item.urid">
                    <div class="rank_icon">
                        <template v-if="item.rank <= 3">
                            <img src="@/assets/img/rank/1.png" :alt="item.rank" v-if="item.rank == 1" />
                            <img src="@/assets/img/rank/2.png" :alt="item.rank" v-if="item.rank == 2" />
                            <img src="@/assets/img/rank/3.png" :alt="item.rank" v-if="item.rank == 3" />
                        </template>
                        <span v-else>{{ item.rank }}</span>
                    </div>
                    <div class="rank_avatar"><van-image round width=".91rem" height=".91rem" :src="item.avatarurl" /></div>
                    <div class="rank_user">
                        <div class="oneline">{{ item.nickname }}</div>
                        <div><van-image v-if="item.medalurl" width=".84rem" height="0.3rem" style="margin-right:.1rem" :src="item.medalurl" /><span>{{item.medalname}}</span></div>
                    </div>
                    <div class="rank_btn">
                        <div @click="view(item)">查看</div>
                        <div>已完成{{item.num}}/30</div>
                    </div>
                </div>
            </div>
        </div>
      </List>
      <Empty description="暂无数据" />
      <Popup v-model="show" closeable position="bottom" :style="{ height: '100%' }">
        <div class="vhtml" v-html="rules"></div>
      </Popup>
  </div>
</template>
<script>
import { Image, Popup, List, Empty, Dialog, ImagePreview } from "vant";
import moment from "moment";

export default {
  components: {
    VanImage: Image,
    Popup,
    List,
    Empty,
    Dialog,
    ImagePreview
  },
  name: "hpIndex",
  computed: {
  },
  filters: {
    startstate(date) {
        if(date){
            return moment(date*1000).format("YYYY年M月D日");
        }else{
            return 'xx-xx';
        }

    },
    state(date) {
        if(date){
            return moment(date*1000).format("M月D日");
        }else{
            return 'xx-xx';
        }

    },
  },
  data() {
    return {
      currentItem: "",
      tabs: [],
      detail: "",
      loading: false,
      finished: false,
      page: 1,
      rankList: [],
      type: 0,
      first: 0,
      two: 0,
      three: 0,
      rules: '',
      show: false,
      matchinfo: {},
      status: 0 //0:未开始，1:进行中，2:已结束
    };
  },
  methods: {
    getRankList: function () {
        this.$api.activity.hpGrank({matchid:this.$route.params.matchid,page:this.page}).then((res) =>{
            let {list,page,pages,mytotal,matchinfo} = res.data;
            let sys_time = res.sys_time;
            this.rules = matchinfo.intro;
            this.matchinfo = matchinfo;
            this.loading = false;
            if (sys_time < matchinfo.start_time*1) {
                this.status = 0;
            } else if (sys_time > matchinfo.end_time*1) {
                this.status = 2;
            } else {
                this.status = 1;
            }
            if(+mytotal===0){
                this.first = 0;
                this.two = 0;
                this.three = 0;
                this.type = 0;
            }else if(+mytotal>0&&mytotal*1<=10){
                this.first = mytotal*1;
                this.two = 0;
                this.three = 0;
                this.type = 1;
            }else if(+mytotal>10&&mytotal*1<=20){
                this.first = 10;
                this.two = mytotal*1 - 10;
                this.three = 0;
                this.type = 2;
            }else if(+mytotal>20){
                this.first = 10;
                this.two = 10;
                this.three = mytotal*1 - 20;
                this.type = 3;
            }
            list.forEach((item, index) => {
                if(item.num*1===0){
                    item.medalurl = '';
                    item.medalname = '未获得任何勋章';
                } else if(item.num*1<=10&&item.num*1>0){
                    item.medalurl = 'https://oss.mcloud.moveclub.cn/mpms/20210309/1615278716-6047327c20d49.png';
                    item.medalname = '已获得初级勋章';
                }else if(item.num*1<=20&&item.num*1>10){
                    item.medalurl = 'https://oss.mcloud.moveclub.cn/mpms/20210309/1615278722-60473282f3ee2.png';
                    item.medalname = '已获得中级勋章';
                }else if(item.num*1>20){
                    item.medalurl = 'https://oss.mcloud.moveclub.cn/mpms/20210309/1615278709-60473275eed99.png';
                    item.medalname = '已获得高级勋章';
                }
                if (index > 0 && +item.num === +list[index - 1]['num']) {
                    item.rank = list[index - 1]['rank']
                } else if (index === 0) {
                    if (this.rankList.length) {
                    let last = this.rankList[this.rankList.length - 1]
                    if (+item.num === +last.num) {
                        item.rank = last.rank
                    } else {
                        item.rank = last['rank'] * 1 + 1
                    }
                    } else {
                    item.rank = 1
                    }
                } else {
                    item.rank = list[index - 1]['rank'] * 1 + 1
                }
            })
            if (+page === 1) {
              this.rankList = list;
            } else {
              this.rankList = this.rankList.concat(list);
            }
            if (+page >= pages) {
              this.finished = true;
            } else {
              this.page++;
            }
        })
    },
    view(item) {
        if(item.images.length===0){
            this.$toast.fail('暂无记录');
            return;
        }
        let images = []
        item.images.forEach((io)=>{
            images.push(io.imageurl)
        })
        ImagePreview(images)
    },
    goluck() {
        if(this.status===0){
            Dialog.alert({
                title: '提醒',
                message: '活动暂未开始',
            }).then(() => {
            // on close
            });
            return;
        }
        this.$router.push({name:'hp_luckdraw', params: {acid:this.matchinfo.acid}})
    },
    goto() {
        if(this.status===0){
            Dialog.alert({
                title: '提醒',
                message: '活动暂未开始',
            }).then(() => {
            // on close
            });
            return;
        }

        this.$router.push({name:'hp_join', params: {matchid:this.$route.params.matchid,type:1}})
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.getRankList();
    });
  },
//   created() {
//       this.getRankList();
//   },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>

